<template>
  <div
    class="container"
    :class="{ 'fx-mobile': isFxMobile }"
  >
    <router-link
      v-if="!title"
      class="bg"
      :to="link"
    >
      <div
        class="bg1"
        @click="toTmall"
      >
        <h1>
          {{ title }}
          <span v-if="revision === '2'">{{ revision }}</span>
          <span
            v-else
            class="revision-mobile"
          >{{ revision }}</span>
        </h1>
        <p>{{ desc }}</p>
      </div>
      <div
        v-if="title"
        class="image"
        :style="{backgroundImage: `url(${image})`}"
      />
    </router-link>
    <router-link
      v-else
      :to="link"
    >
      <div class="texts">
        <h1>
          {{ title }}
          <span v-if="revision === '2'">{{ revision }}</span>
          <span
            v-else
            class="revision-mobile"
          >{{ revision }}</span>
        </h1>
        <p>{{ desc }}</p>
      </div>
      <div
        v-if="title"
        class="image"
        :style="{backgroundImage: `url(${image})`}"
      />
      <router-link
        v-if="title"
        :to="link"
      >
        <button>了解更多</button>
      </router-link>
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    revision: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      image: null,
      isFxMobile: false
    }
  },
  mounted: function () {
    if (this.revision === '移动版') {
      this.image = require('@/assets/featured/fx-mobile@2x.png')
      this.isFxMobile = true
    } else {
      this.image = require('@/assets/featured/BIAS-FX-2@2x.png')
    }
  },
  methods: {
    toTmall () {
      window.open('https://m.tb.cn/h.g2gnZJkxNWvX3qv?tk=boD8WFHQMaj', '_blank')
      // window.location.href = 'https://m.tb.cn/h.g2gnZJkxNWvX3qv?tk=boD8WFHQMaj'
    }
  }
}
</script>

<style scoped>
.container > a {
  width: 100%;
  height: 100%;
  text-decoration: none;
  padding: 32px;
}
a:link,
a:visited {
  font-weight: 300;
}
.container {
  overflow: hidden;
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  opacity: 1;
  border-radius: 10px;
  background-image: radial-gradient(circle at 53% 22%, #43484f, #111114);
  margin: 12px;
  max-width: calc(100% - 24px);

  /* padding: 32px; */
}
.fx-mobile {
  background-image: linear-gradient(333deg, #12121b, #26394b);
}
.bg {
  min-height: 490px;
  background: url('../assets/index/bg.jpg') no-repeat;
  background-size: contain;
  background-position: center;

}
 .bg1 {
   width: 100%;
   height: 100%;
 }
@media screen and (max-width: 768px) {
  .container {
    flex: 2 2 100%;
  }
}
.texts h1 {
  width: 100%;
  font-weight: 700;
  white-space: nowrap;
  margin: 0;
}
.texts h1 span {
  font-weight: 300;
}
.texts h1 span.revision-mobile {
  font-size: 30px;
}
.texts p {
  display: block;
  width: 100%;
}
.image {
  min-height: 249px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
button {
  margin-top: 49px;
}
a {
  width: 120px;
}
h1 {
  font-size: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/featured-small.vue